module.exports = __webpack_public_path__ + "static/media/18.b6b2ae1b.png";